<template>
  <table class="tbl select-tbl">
    <colgroup>
      <col v-for="item in $slots.header" v-if="item.componentOptions" :width="item.componentOptions.propsData.width" :key="uuidv4()" />
    </colgroup>
    <thead class="no-drag">
      <tr>
        <slot name="header">
        </slot>
      </tr>
    </thead>
    <tbody v-if="1 > datasource.length">
      <tr>
        <td :colspan="noDataSpan" style="text-align:center"> {{noDataText}}</td>
      </tr>
    </tbody>
    <tbody v-if="0 < datasource.length">
      <slot></slot>
    </tbody>
  </table>
</template>

<script>
import DataTableColumn from '@/components/common/DataTableColumn';
export default {
  props: {
    noDataText: { type: String, default: function() { return '데이터가 없습니다.';}},
    value: Object,
    datasource: { type: Array, default: function() { return [{}];}},
    schema: { type: Object, default: function() { return {};}},
    useCustomHeader: { type: Boolean, default: function() { return false;}},
    noDataSpan: { type: Number, default: function() { return 10;}},
  },
  data(){
    return {
      // headerItems: []
    }
  },
  mounted(){
    // this.makeHedaer();
  },
  components:{
    DataTableColumn
  },
  methods: {
    init(){
      if(this.schema && !this.useCustomHeader){

      }
    },
    hasCustomColumn(name){
      //var result = false;

      return this.$_.find(this.$slots.default, function(item){ return item.name == name});
    },
    makeHedaer(){

      console.log(this.$slots.header)
      this.$slots.header.forEach(function(vnode) {

        if(!vnode.componentOptions) return ;
        var item = vnode.componentOptions.propsData;

        item.key = this.uuidv4();
        this.headerItems.push(item);
        /*

        if (vnode.tag.indexOf('a-child-component') > -1) {
           vnode.elm.addEventListener('click', this.handleClick, true) // <-- NATIVE event :-(
        }
        */
      }.bind(this))
    }
  }
}
</script>

<style>

</style>
